import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { HomeOwnerStatus } from "Globals/Models/HomeOwnerStatus";
import { HomeOwnerStatusEnum } from "Globals/Models/HomeOwnerStatusEnum";

export class HomeOwnerStatusStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private homeOwnerStatus: HomeOwnerStatus[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.homeOwnerStatus = initialState.homeOwnerStatus;
    }

    @MobX.action
    public getHomeOwnerStatusName(homeOwnerStatusId: string | null): string {
        if (homeOwnerStatusId == null) return "";
        if (homeOwnerStatusId == "0") return "Error";
        let lender = this.getSortedByOrdinal.find((lender) => homeOwnerStatusId === lender.id);
        return lender ? lender.name : "Unknown";
    }
    @MobX.action
    public getEnumFromId(id: string): HomeOwnerStatusEnum {
        let status = this.homeOwnerStatus.find((s) => s.id == id);
        if (!status) return HomeOwnerStatusEnum.Selling; // default to selling
        if (status.type == 1) return HomeOwnerStatusEnum.Selling;
        if (status.type == 2) return HomeOwnerStatusEnum.Sold;
        if (status.type == 3) return HomeOwnerStatusEnum.RemovingNameFromMortgage;
        return HomeOwnerStatusEnum.RemovedNameFromMortgage;
    }

    @MobX.computed
    public get getSortedByOrdinal(): HomeOwnerStatus[] {
        return this.homeOwnerStatus.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((a) => ({ value: a.id, key: a.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
